/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { COLORS } from "./hero.constants";

export default function HeroSection({ isArabic }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section
      className="text-center"
      style={{
        padding: "100px 0 110px",
        background: COLORS.gradient,
        color: COLORS.textLight,
      }}
    >
      <div className="container">
        <h1
          className="fw-bold mb-4"
          style={{
            color: COLORS.gold,
            fontSize: "2.7rem",
            fontFamily: "'Cairo', sans-serif",
            direction: isArabic ? "rtl" : "ltr",
          }}
        >
          {t("hero.subtitle")}
        </h1>

        <p
          style={{
            maxWidth: 750,
            margin: "0 auto",
            fontSize: "1.15rem",
            lineHeight: 1.8,
            opacity: 0.9,
          }}
        >
          {isArabic
            ? "اكتشف مجموعة متنوعة من التطبيقات التي تساعدك في إدارة متجرك بكفاءة."
            : "Discover a variety of apps that help you manage your store efficiently."}
        </p>

        <div style={{ marginTop: "25px" }}>
          <button
            className="btn fw-semibold px-4 py-2"
            style={{
              background: COLORS.gold,
              color: COLORS.darkPurple,
              borderRadius: "10px",
              fontSize: "1.05rem",
            }}
            onClick={() => navigate("/signup")}
          >
            {t("hero.button")}
          </button>
        </div>
      </div>
    </section>
  );
}
